import React , { useEffect, useState, useRef } from 'react';
import { Modal, Button, Dropdown } from 'app/components';
import { sections, vendorAgreement as content } from '../mockdata';

import './style';

const VendorModal = ({ isOpen, onClose, onConfirm, organizerName, loading }) => {

const [activeSection, setActiveSection] = useState(sections[0]);
  const contentRef = useRef(null);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const container = contentRef.current;
      if (container) {
        const { scrollTop, offsetHeight } = container;
        let activeIndex = -1;

        sectionRefs.current.forEach((ref, index) => {
          if (ref.current) {
            const { offsetTop } = ref.current;
            if (scrollTop >= offsetTop - offsetHeight / 2) {
              activeIndex = index;
            }
          }
        });

        if (activeIndex !== -1 && sections[activeIndex] !== activeSection) {
          setActiveSection(sections[activeIndex]);
        }
      }
    };

    const scrollContainer = contentRef.current;
    scrollContainer?.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [sections, activeSection]);


  const scrollToSection = (index) => {
    if (sectionRefs.current[index]?.current) {
      sectionRefs.current[index].current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const onMobileSectionChange = (value) => {
    const index = sections.findIndex((section) => section === value);
    if (index > -1) {
      setActiveSection(value);
      scrollToSection(index);
    }
  };

  const handleDownload = () => {
    // const fileUrl = ""; 
    // const link = document.createElement("a");
    // link.href = fileUrl;
    // link.download = "VENDOR_AGREEMENT.pdf";
    // link.click();
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        size="small"
        className="vendor-modal"
        title={(<div className="heading-24 flex w-full justify-between md:mb-8">
          <h1>Terms of Service</h1>
          {/* <Button 
            type="tertiary" 
            className="w-fit"
            onClick={handleDownload}
          >
            Download PDF
          </Button> */}
        </div>)}
      >
        <div className='vendor-modal-body flex gap-8 h-full relative'>
          <div className="mobile-section-dropdown md:hidden w-full">
            <Dropdown
              width="100%"
              value={activeSection}
              options={sections.map((section) => ({ id: section, label: section }))}
              onChange={onMobileSectionChange}
            />
          </div>
          <div className='hidden md:flex flex-col gap-5 overflow-y-auto min-w-[280px]'>
             {sections.map((section, index) => (
              <p
                key={section}
                className={`cursor-pointer label-16 text-grey-70 w-max ${
                  activeSection === section ? "text-primary" : ""
                }`}
                aria-current={activeSection === section ? "true" : "false"}
                onClick={() => scrollToSection(index)}
              >
                {section}
              </p>
             ))}
          </div>
          <div className='relative h-full w-full vendor-modal-content-wrapper'>
             <div
              ref={contentRef}
              style={{ height: "calc(100% - 80px)" }}
              className="overflow-y-scroll font-times break-normal text-justify"
            >
              <p className='text-base font-normal leading-normal'>
                  <div className='text-lg font-semibold underline text-center mb-2'>VENDOR SUPPLY AGREEMENT</div>
                  This Vendor Supply Agreement (Hereinafter referred to as <span className='font-semibold'>“Agreement”</span>) is made, 
                  executed and comes into force on and from the date of Registration of the Second Party on the website
                  of the First Party. (Hereinafter referred to as <span className='font-semibold'>“Effective Date”</span>)<br/><br/>

                  <div className='text-lg font-semibold text-center mb-2'>BY AND BETWEEN;</div>
                  This Vendor’s Agreement ("Agreement") is made by and between Dankbarkeit Entertainment LLP, a limited liability partnership incorporated duly under the provisions of Limited Liability Partnership Act-2008, and having its LLPIN; ACA-5919 and having its registered office at INNOV8 SKCL TECH SQUARE NO:14, 2ND FLOOR, SIDCO T.V.K INDUSTRIAL ESTATE GUINDY PARK, GUINDY, CHENNAI-600032 (Herein referred to as “TMT”, which expression shall unless it be repugnant or contrary to the context thereof, means and includes his successors, heirs, representatives, future interest and permitted assigns), and you, the user of the Company’s services, platform, or website ("You", "User", or “Vendor”). By accessing or using the Company’s services, You agree to be bound by the terms and conditions set forth in this Agreement, which governs the relationship between the Company and You.<br/><br/>

                  By checking the box and accepting these Terms and Conditions of this Agreement, you acknowledge that you have read, understood, and agreed to be bound by all the rules, regulations, and obligations contained herein. Your consent signifies your commitment to adhere to these Terms and Conditions in their entirety. Failure to comply with any of the provisions may result in the termination of your access or other legal remedies as outlined in this agreement.
                  It is clarified that <span className='font-semibold'>‘TMT’</span> and <span className='font-semibold'>‘Vendor’ </span> 
                  wherever the context so requires individually shall be referred to as “Party” and collectively as “Parties”.
              </p>
              <br/>

              {/* Sections */}
              {content.map((section, i) => (
                <div
                  ref={(el) => (sectionRefs.current[i] = { current: el })}
                  key={`section-${i}`}
                  className="mb-4"
                >
                  <h1 className='text-xl font-semibold mb-1'>{section.title}</h1>
                  <ul className="pl-4 list-inside">
                    {section.points.map((point, j) => (<>
                      <li key={`point-${i}-${j}`} className='space-y-4 flex'>
                        <span className='font-semibold mr-4'>{i+1}.{j+1} </span>{point}
                      </li>
                        <ul className='pl-8 list-inside'>
                          {section.subpoints && section.subpoints[j+1]?.map((subpoint,k)=>(
                            <li key={`point-${i}-${j}-${k}`} className='space-y-4 flex'>
                              <span className='font-semibold mr-4'>{i+1}.{j+1}.{k+1}</span>{subpoint}
                            </li>
                          ))}
                        </ul></>
                    ))}
                  </ul>
                </div>
              ))}

              <br/>
              {/* <p className='text-base font-normal leading-normal'>
                <div className='text-lg font-semibold text-center'>ANNEXURE: A</div>
                <div className='text-lg font-semibold text-center mb-2'>PAYMENT CYCLE</div>
                For sale of tickets for through our Platform, we will be charging 2% commission from the event organisers and other taxes as applicable
              </p> */}
            </div>

            <div className='w-full flex items-center justify-center gap-3 absolute bottom-0 left-0 bg-white'>
              <Button 
                type="tertiary" 
                className="vendor-btn"
                onClick={onClose}
                disabled={loading}
              >
                  Decline
              </Button>
              <Button 
                className="vendor-btn"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? (
                  <span className="w-5 h-5 border-2 border-t-2 border-gray-200 border-t-primary rounded-full animate-spin"></span>
                ) : (
                  'Accept'
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default VendorModal;
